module.exports = __webpack_public_path__ + "48c526b3303c6f41ca4680a3910e23b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-19.png
// module id = 2939
// module chunks = 0